import Vue from 'vue';
import Router from 'vue-router';

import store from '@/store';

import Layout from '@/components/Layout.vue';

import Login from '@/pages/Login.vue';
import ChecklistsList from '@/pages/checklists/ChecklistsList.vue';
import ChecklistsForm from '@/pages/checklists/ChecklistsForm.vue';
import CountriesList from '@/pages/countries/CountriesList.vue';
import CountriesForm from '@/pages/countries/CountriesForm.vue';
import PppElementsList from '@/pages/pppelements/PppElementsList.vue';
import PppElementsForm from '@/pages/pppelements/PppElementsForm.vue';
import InfoPagesList from '@/pages/infopages/InfoPagesList.vue';
import InfoPagesForm from '@/pages/infopages/InfoPagesForm.vue';
import Statistics from '@/pages/Statistics.vue';
import Logs from '@/pages/Logs.vue';
import UserManual from '@/pages/UserManual.vue';
import PageNotFound from '@/pages/PageNotFound.vue';
import PageError from '@/pages/PageError.vue';
import NotificationsList from '@/pages/notifications/NotificationsList.vue';
import NotificationsForm from '@/pages/notifications/NotificationsForm.vue';
import NotificationsView from '@/pages/notifications/NotificationsView.vue';

Vue.use(Router);

const requireAuth = (to, from, next) => {
    store.dispatch('auth/verify')
        .then((response) => {
            if (response === true) {
                next();
            } else {
                // next({ name: 'login' });
                store.dispatch('auth/login');
            }
        })
        .catch(() => {
            next({ name: 'error' });
        });
};

const requireNotAuth = (to, from, next) => {
    store.dispatch('auth/verify')
        .then((response) => {
            if (response === true) {
                next({ name: 'checklists' });
            } else {
                // next();
                store.dispatch('auth/login');
            }
        })
        .catch(() => {
            next({ name: 'error' });
        });
};

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: 'checklists',
        },
        {
            path: '/error',
            name: 'error',
            component: PageError,
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            beforeEnter: requireNotAuth,
        },
        {
            path: '/',
            component: Layout,
            beforeEnter: requireAuth,
            children: [
                {
                    path: 'checklists',
                    component: {
                        template: '<router-view />',
                    },
                    children: [
                        {
                            path: '/',
                            name: 'checklists',
                            component: ChecklistsList,
                        },
                        {
                            path: 'add',
                            name: 'checklists.add',
                            component: ChecklistsForm,
                        },
                        {
                            path: 'edit/:id',
                            name: 'checklists.edit',
                            component: ChecklistsForm,
                        },
                    ],
                },
                {
                    path: 'countries',
                    component: {
                        template: '<router-view />',
                    },
                    children: [
                        {
                            path: '/',
                            name: 'countries',
                            component: CountriesList,
                        },
                        {
                            path: 'add',
                            name: 'countries.add',
                            component: CountriesForm,
                        },
                        {
                            path: 'edit/:id',
                            name: 'countries.edit',
                            component: CountriesForm,
                        },
                    ],
                },
                {
                    path: 'infopages',
                    component: {
                        template: '<router-view />',
                    },
                    children: [
                        {
                            path: '/',
                            name: 'infopages',
                            component: InfoPagesList,
                        },
                        {
                            path: 'edit/:id',
                            name: 'infopages.edit',
                            component: InfoPagesForm,
                        },
                    ],
                },
                {
                    path: 'pppelements',
                    component: {
                        template: '<router-view />',
                    },
                    children: [
                        {
                            path: '/',
                            name: 'pppelements',
                            component: PppElementsList,
                        },
                        {
                            path: 'add',
                            name: 'pppelements.add',
                            component: PppElementsForm,
                        },
                        {
                            path: 'edit/:id',
                            name: 'pppelements.edit',
                            component: PppElementsForm,
                        },
                    ],
                },
                {
                    path: 'statistics',
                    name: 'statistics',
                    component: Statistics,
                },
                {
                    path: 'logs',
                    name: 'logs',
                    component: Logs,
                },
                {
                    path: 'user-manual',
                    name: 'user-manual',
                    component: UserManual,
                },
                {
                    path: 'notifications',
                    component: {
                        template: '<router-view />',
                    },
                    children: [
                        {
                            path: '/',
                            name: 'notifications',
                            component: NotificationsList,
                        },
                        {
                            path: 'add',
                            name: 'notifications.add',
                            component: NotificationsForm,
                        },
                        {
                            path: 'view/:id',
                            name: 'notifications.view',
                            component: NotificationsView,
                        },
                    ],
                },
            ],
        },
        {
            path: '*',
            component: PageNotFound,
        },
    ],
});
